import { render, staticRenderFns } from "./CurriculumSyllabusNECPure.vue?vue&type=template&id=61585cf1&scoped=true&"
import script from "./CurriculumSyllabusNECPure.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusNECPure.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSyllabusNECPure.vue?vue&type=style&index=0&id=61585cf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61585cf1",
  null
  
)

export default component.exports